import React from 'react';
import PageLayout from '../../layout/PageLayout';
import './TermsAndConditions.css';

const TermsAndConditions = () => {
  return (
    <PageLayout>
      <div className="rtc-terms-container">
        <h1 className="page-title">Terms and Conditions</h1>
        <p>
          Effective Date: <span className="policy-update-date">01-Apr-2026</span>
        </p>
        <p className="rtc-text">
          Please read these Terms and Conditions carefully before engaging with
          RuhiTech Solutions for any services or products. By accessing our
          website, engaging our services, or using our products, you agree to be
          bound by these terms.
        </p>

        <section className="rtc-section">
          <h2 className="rtc-heading">1. About RuhiTech Solutions</h2>
          <p className="rtc-text">
            RuhiTech Solutions is a technology company providing custom software
            development, web and mobile application development, AI and
            automation integrations, digital consulting services, and proprietary
            software products to clients and businesses. These Terms govern all
            engagements, transactions, and interactions with RuhiTech Solutions.
          </p>
        </section>

        <section className="rtc-section">
          <h2 className="rtc-heading">2. Services</h2>
          <p className="rtc-text">
            RuhiTech Solutions offers a range of technology services including
            but not limited to custom web and mobile application development, AI
            and machine learning integrations, business automation tools, SaaS
            platform development, and technology consulting. The specific scope,
            deliverables, timelines, and pricing for each engagement shall be
            defined in a separate Statement of Work (SOW), proposal, or service
            agreement agreed upon by both parties.
          </p>
        </section>

        <section className="rtc-section">
          <h2 className="rtc-heading">3. Client Responsibilities</h2>
          <p className="rtc-text">
            To ensure successful project delivery, the client agrees to:
          </p>
          <ul className="rtc-text">
            <li>Provide accurate, complete, and timely information and requirements.</li>
            <li>Designate a point of contact for communication and decision-making.</li>
            <li>Provide timely feedback and approvals at agreed project milestones.</li>
            <li>Grant necessary access to systems, credentials, or resources required for project delivery.</li>
            <li>Ensure that any content, data, or materials provided to RuhiTech Solutions do not infringe any third-party intellectual property rights.</li>
          </ul>
          <p className="rtc-text">
            Delays caused by the client's failure to meet these responsibilities
            may result in revised timelines and additional costs, which will be
            communicated in advance.
          </p>
        </section>

        <section className="rtc-section">
          <h2 className="rtc-heading">4. Intellectual Property</h2>
          <p className="rtc-text">
            <strong>Client Work:</strong> Upon full payment of all applicable
            fees, the client shall own the intellectual property rights to the
            custom deliverables created specifically for them under the
            engagement, unless otherwise agreed in writing.
          </p>
          <p className="rtc-text">
            <strong>RuhiTech Solutions Products:</strong> All proprietary
            software products, platforms, frameworks, and tools developed and
            owned by RuhiTech Solutions remain the exclusive intellectual
            property of RuhiTech Solutions. Clients are granted a
            non-exclusive, non-transferable licence to use such products subject
            to the terms of their specific product licence agreement.
          </p>
          <p className="rtc-text">
            <strong>Pre-existing IP:</strong> Any tools, libraries, frameworks,
            or technologies owned by RuhiTech Solutions prior to or developed
            independently of a client engagement remain the property of
            RuhiTech Solutions.
          </p>
          <p className="rtc-text">
            Unauthorised reproduction, distribution, reverse engineering, or
            commercial use of RuhiTech Solutions' intellectual property is
            strictly prohibited and may result in legal action.
          </p>
        </section>

        <section className="rtc-section">
          <h2 className="rtc-heading">5. Payment Terms</h2>
          <p className="rtc-text">
            Payment terms for services shall be as specified in the agreed
            proposal or SOW. Unless otherwise stated:
          </p>
          <ul className="rtc-text">
            <li>Invoices are due within 15 days of the invoice date.</li>
            <li>Milestone-based payments must be cleared before the next phase of development commences.</li>
            <li>Late payments may attract an interest charge of 1.5% per month on the outstanding amount.</li>
            <li>RuhiTech Solutions reserves the right to suspend or pause work if payments are overdue by more than 15 days.</li>
          </ul>
          <p className="rtc-text">
            All prices are quoted in Indian Rupees (INR) unless explicitly stated otherwise. Applicable taxes (including GST) will be added to invoices as required by law.
          </p>
        </section>

        <section className="rtc-section">
          <h2 className="rtc-heading">6. Confidentiality</h2>
          <p className="rtc-text">
            Both parties agree to keep confidential any proprietary or sensitive
            information shared during the engagement. RuhiTech Solutions will
            not disclose client business information, project details, or data to
            any third party without the client's prior written consent, except as
            required by law. This obligation survives the termination of the
            engagement.
          </p>
        </section>

        <section className="rtc-section">
          <h2 className="rtc-heading">7. Website Usage</h2>
          <p className="rtc-text">
            By accessing the RuhiTech Solutions website, you agree to use it
            only for lawful purposes. You must not engage in any activity that
            disrupts or interferes with the website's functionality, including
            hacking, data scraping, introducing malware, or any other malicious
            activity. Unauthorised use may result in legal action.
          </p>
        </section>

        <section className="rtc-section">
          <h2 className="rtc-heading">8. Warranties and Disclaimers</h2>
          <p className="rtc-text">
            RuhiTech Solutions warrants that services will be performed with
            reasonable skill and care in accordance with the agreed
            specifications. We do not warrant that our services or products will
            be error-free or uninterrupted. Any warranties beyond those expressly
            stated in the SOW are disclaimed to the fullest extent permitted by
            law.
          </p>
        </section>

        <section className="rtc-section">
          <h2 className="rtc-heading">9. Limitation of Liability</h2>
          <p className="rtc-text">
            To the maximum extent permitted by applicable law, RuhiTech
            Solutions shall not be liable for any indirect, incidental,
            consequential, special, or punitive damages arising out of or in
            connection with our services, products, or website, including but
            not limited to loss of data, loss of revenue, or loss of business
            opportunity. Our total aggregate liability to any client shall not
            exceed the total fees paid by that client for the specific service
            giving rise to the claim.
          </p>
        </section>

        <section className="rtc-section">
          <h2 className="rtc-heading">10. Termination</h2>
          <p className="rtc-text">
            Either party may terminate a service engagement by providing written
            notice as specified in the relevant SOW or agreement. Upon
            termination, the client shall pay for all work completed up to the
            date of termination. RuhiTech Solutions reserves the right to
            immediately terminate an engagement in cases of non-payment, breach
            of these terms, or conduct that is unlawful or harmful.
          </p>
        </section>

        <section className="rtc-section">
          <h2 className="rtc-heading">11. Changes to These Terms</h2>
          <p className="rtc-text">
            RuhiTech Solutions reserves the right to amend these Terms and
            Conditions at any time. Updated terms will be posted on this page
            with a revised effective date. Continued use of our website or
            services after changes are posted constitutes your acceptance of the
            updated terms.
          </p>
        </section>

        <section className="rtc-section">
          <h2 className="rtc-heading">12. Governing Law</h2>
          <p className="rtc-text">
            These Terms and Conditions shall be governed by and construed in
            accordance with the laws of India. Any disputes arising out of or
            in connection with these terms shall be subject to the exclusive
            jurisdiction of the competent courts in Chennai, Tamil Nadu.
          </p>
        </section>

        <section className="rtc-section">
          <h2 className="rtc-heading">Contact Us</h2>
          <p className="rtc-text">
            For any queries regarding these Terms and Conditions, please contact:
            <br />
            <strong>RuhiTech Solutions</strong>
            <br />
            Email: <a href="mailto:contact@ruhitechsolutions.com">contact@ruhitechsolutions.com</a>
            <br />
            Phone: +91 8220343006
            <br />
            Address: #140, 1st Floor, Plaza Center, No 129, G.N. Chettey Road,
            Chennai - 600006
          </p>
        </section>
      </div>
    </PageLayout>
  );
};

export default TermsAndConditions;
